import { Box, Dialog, DialogContent, DialogTitle, Typography,TextField,Button } from "@mui/material";
import { format,subDays } from "date-fns";
import { useState } from "react";

export default function DialogHistoryDateSelector({open,onClose,onGoClicked,startTime,endTime,setStartTime,setEndTime}){


    return(
    <Dialog open={open} onClose={onClose}>
        <DialogTitle>Pilih Tanggal</DialogTitle>
        <DialogContent>
            <Box>
                <Typography variant='body1'>Dari :</Typography>
                <TextField sx={{width : "250px"}} onChange={(e) => {setStartTime(e.target.value)}} type={"datetime-local"}   defaultValue={startTime} size="small"/>
                <Typography sx={{mt : 2}} variant='body1'>Sampai :</Typography>
                <TextField sx={{width : "250px"}}onChange={(e) => {setEndTime(e.target.value)}} type={"datetime-local"}   defaultValue={endTime}  size="small"/>
                <Box sx={{mt : 3}} display={"flex"} justifyContent={"flex-end"}>
                    <Button  variant="contained" onClick={() => {onGoClicked()}}>Pilih</Button>
                </Box>
            </Box>
                
        </DialogContent>
    </Dialog>
    )
}